module.exports = __webpack_public_path__ + "static/media/Toucan_laptop.c93173b8.gif";